/**
 * Place all functions that are used application wide in this file.
 * NOTE: Please document your code
 */




/**
 * @description - Formats the description for a popup so that all references to an ID field are 
 * compatible with RTL and LTR.
 * NOTE: Use this when displaying a message that contains ID fields
 * @param {string} message - message string for the popup.
 * @param {string} direction - either 'ltr' or 'rtl' depending on the currnent language selected.
 * @returns {React.JSX}
 */
export const formatPopupMessage = (message, direction)=> {

  //["hcp unique id", "hco unique id", "hcp reference id", "hco reference id", "onekey id"]
    //extract all words
    const words = message.split(/(hco|hcp)\s+(unique|reference|enterprise)\s+id:\s*\w+|onekey\s+id:\s*\w+/gi);
    //extract all id references
    const extractedIds = message.match(/(hco|hcp)\s+(unique|reference|enterprise)\s+id:\s*\w+|onekey\s+id:\s*\w+/gi);
    let counter = 0;
    return (
      //loop through and re-insert the extracted ids as formatted rtl
      words.map(word => {
        if(counter < (extractedIds?.length || 0)){
          return (
            <>
              {word}
              <span className="_wg-exclude" dir={direction}>{extractedIds[counter].split(/:/)[0]}:</span>
              <span className="_wg-exclude" dir={direction}>{extractedIds[counter++].split(/:/)[1]}</span>
            </>
          )
        }
        //If there are no matching id fields, then just return the text as it is.
        return word
      })
    )
  }

export const sortTranslated = (values) => {
  if(values && Array.isArray(values))
  return values?.slice().sort((a,b) => {
    if(typeof a == 'string'){
      const getCategory = str => {
        const firstChar = str.toString().trim().charAt(0);
        const code = firstChar.charCodeAt(0)
  
        if((code >= 65 && code <= 90) || (code >= 97 && code <= 122)){
          return 1
        }
      
        if((code >= 48 && code <= 57) || (/[!@#$%^&*(),.?":{}|<>_\-+=~`]/.test(firstChar))){
          return 2
        }
        
        return 0
      }
      const catA = getCategory(a);
      const catB = getCategory(b);
  
      if(catA !== catB) return catA - catB;
      return a?.localeCompare(b)
    }
  })
}